<template>
  <v-row>
    <v-col cols="12">
      <v-sheet>
        <v-col cols="12">
          <v-lazy
            :options="{
              threshold: .5
            }"
            min-height="200"
            transition="fade-transition"
          >
          
            <showIdeaProjectsStand 
              v-if="!loading && entrepreneurship.type_postulations_id===1"
              :data="data"
              :logo="customization.idea_project_logo"
              :color="customization.idea_project_color"
              :project_gallery_mode="customization.project_gallery_mode"/>
    
            <showIdeaProjectsSchoolsStand 
              v-if="!loading && entrepreneurship.type_postulations_id===2" 
              :data="data"
              :logo="customization.idea_project_school_logo"
              :color="customization.idea_project_school_color"
              :project_gallery_mode="customization.project_gallery_mode"/>
                  
            <showBusinessModelsStand
              v-if="!loading && entrepreneurship.type_postulations_id===3"
              :data="data" 
              :logo="customization.business_model_logo"
              :color="customization.business_model_color"
              :project_gallery_mode="customization.project_gallery_mode"/>
          </v-lazy>
        </v-col>
      </v-sheet>
    </v-col>
    
    <v-col cols="12" class="pt-8 pb-8 d-sm-flex">
      <v-btn
        :block="$vuetify.breakpoint.xsOnly"
        depressed
        dark
        color="#0097B4"
        :to="{ name: 'myWindow'}"
        >
        <v-icon left>
          mdi-arrow-left
        </v-icon>
        Volver
      </v-btn>

      <v-spacer />

    </v-col>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300"
      >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-row>
</template>

<script>
  import axios from 'axios'
  import { mapGetters } from 'vuex'
  import download from 'downloadjs'
  const VUE_URL_API = process.env.VUE_APP_URL_API
  import showIdeaProjectsStand from '@/components/stand/preview/showIdeaProjectsStandPreview.vue'
  import showIdeaProjectsSchoolsStand from '@/components/stand/preview/showIdeaProjectsSchoolsStandPreview.vue'
  import showBusinessModelsStand from '@/components/stand/preview/showBusinessModelsStandPreview.vue'

  export default {
    name: 'previewWindow',
    components: {
      showIdeaProjectsStand,
      showIdeaProjectsSchoolsStand,
      showBusinessModelsStand
    },
    data: () => ({
      loading_download:false,
      loading:true,
      slug:'',
      show: false,
      data:[],
      customization: [],
      entrepreneurship:[],
      team:[]
    }),
    computed: {
      ...mapGetters([ 
          'convocation_form', 'edition'
      ])
    },
    methods:{
      async getCustomizationProjectGallery(){
        const url = 'edition/customization/'+ this.edition.edition.slug+'/projects-gallery'
        await axios.get(url).then(response =>{
          this.customization = response.data.data
          this.loading = false
        }).catch(error => {
          this.loading = false
          console.log(error);
        })
      },

      async getEntrepreneurship(){
        // await axios.get('participant/entrepreneurship-windows/'+this.slug).then(response =>{
        await axios.get('entrepreneurship-window/'+ this.convocation_form.convocation_form.id ).then(response =>{
          this.data = response.data.data
          this.entrepreneurship = response.data.data.window
          this.team = response.data.data.team
          this.loading = false
        }).catch(error => {
          this.loading = false
          console.log(error);
        })
      },

      async downloadPDF(){
        this.loading_download=true
        this.url = VUE_URL_API + '/entrepreneurship-windows/'+this.slug+'/generate-pdf'
        await axios.get(
          this.url, 
          {responseType: 'blob'}
        ).then((response) => {
          const content = response.headers['content-type'];
          download(response.data,  this.entrepreneurship.title , content)
          this.loading_download=false
        })
      }
    },

    created(){
       this.slug = this.$route.params.slug;
       this.getEntrepreneurship()
       this.getCustomizationProjectGallery();
    },
  }
</script>
<style scoped>
.images {
  position: fixed;
}
.centered {
  position: absolute;
  top: 35vh;
  left: 10%;
  right:10%;
  transform: translate(0%, -80%);
}

.image-landing{
	position: relative;
	max-width: 100vw;
  height: 30vh;
	width: 100%;
  border-bottom: 5px solid #00a1b8;
}
</style>